// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2019-01-15 08:54:58 +0100 (Tue, 15 Jan 2019) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 98170 $
//  Purpose   : widgets for OPR_Resource records (PDFs, EPubs)
// =============================================================================
export const parts = true
